import { C } from '../../theme/participantTokens';

interface SubmissionDonutProps {
  submitted: number;
  total: number;
  color?: string;
  label?: string;
}

export function SubmissionDonut({
  submitted,
  total,
  color = C.coral,
  label,
}: SubmissionDonutProps) {
  const r = 16;
  const circ = 2 * Math.PI * r;
  const pct = total > 0 ? submitted / total : 0;
  const fill = circ * pct;
  const display = label ?? `${submitted}/${total}`;

  return (
    <svg className="pp-donut" width="44" height="44" viewBox="0 0 44 44" aria-hidden>
      <circle cx="22" cy="22" r={r} fill="none" strokeWidth="3" stroke={C.ruleBright} />
      <circle
        cx="22"
        cy="22"
        r={r}
        fill="none"
        strokeWidth="3"
        stroke={color}
        strokeDasharray={`${fill} ${circ - fill}`}
        strokeDashoffset={circ * 0.25}
        strokeLinecap="round"
        transform="rotate(-90 22 22)"
        opacity={0.75}
      />
      <text
        x="22"
        y="26"
        textAnchor="middle"
        fontFamily="JetBrains Mono"
        fontSize="8"
        fontWeight="700"
        fill={C.textSec}
      >
        {display}
      </text>
    </svg>
  );
}
